// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YG5Fd8gidbXwb2 {
  display: block;
  padding: 14px;
  text-align: left;
  text-decoration: none;
}
.YG5Fd8gidbXwb2:active {
  background-color: var(--marketing-nav-link-hover-background-color);
}
@media (min-width: 992px) {
  .YG5Fd8gidbXwb2:hover {
    transition: background-color 0.3s ease;
    background-color: var(--marketing-nav-link-hover-background-color);
  }
}
.RjDbCRkxpYFSbq {
  display: flex;
  align-items: center;
  padding: 2px 12px 0 2px;
}
.RjDbCRkxpYFSbq svg {
  width: auto;
  height: 16px;
}
.RjDbCRkxpYFSbq svg path,
.RjDbCRkxpYFSbq svg rect {
  fill: var(--marketing-nav-link-icon-color);
}
.IVnsdRRy_1HUXh {
  display: flex;
  padding-bottom: 12px;
  line-height: 16px;
}
.y06dMAd_jgIf31 {
  margin: 0;
  padding-right: 4px;
  color: var(--ds-text, #172b4d);
  font-size: 16px;
  font-weight: var(--ds-font-weight-regular, normal);
  line-height: 24px;
}
.rvyX8CwVhYzXMS p {
  margin: 0;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navLink": `YG5Fd8gidbXwb2`,
	"navIcon": `RjDbCRkxpYFSbq`,
	"navLinkTitleContainer": `IVnsdRRy_1HUXh`,
	"navLinkTitle": `y06dMAd_jgIf31`,
	"navLinkDescription": `rvyX8CwVhYzXMS`
};
export default ___CSS_LOADER_EXPORT___;
